import { render, staticRenderFns } from "./adjustAticleCreate.vue?vue&type=template&id=2c6670de&scoped=true&"
import script from "./adjustAticleCreate.vue?vue&type=script&lang=js&"
export * from "./adjustAticleCreate.vue?vue&type=script&lang=js&"
import style0 from "./adjustAticleCreate.vue?vue&type=style&index=0&id=2c6670de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6670de",
  null
  
)

export default component.exports